e.SSO = {
	init : function(){
		e.SSO.access_logs.init();
		e.SSO.two_factor.init();
	}
};